import { StrictMode } from "react";
import { flushSync } from "react-dom";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "@/src/App";
import "@/app/globals.css";
import "@/src/react.css";

const root = document.getElementById("root")!;
const app = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

if (window.__CHUNO_JOB__ && /^\/jobs\/[a-zA-Z0-9_-]+\/?$/.test(window.location.pathname)) {
  hydrateRoot(root, app);
} else {
  flushSync(() => createRoot(root).render(app));
}

document.documentElement.classList.remove("chuno-boot");
